import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { DateConverterService } from "src/app/core/utils/date-converter.service";
import { StringHelperService } from "src/app/core/utils/string-helper.service";
import { PaymentSearch, PaymentSearchLedger } from "../payment-search.model";
import { PaymentSearchService } from "../payment-search.service";
import { PaymentStatusReferenceModel } from "src/app/core/models/reference-model/reference-general-model";
import { NavigationService } from "src/app/shared/utils/navigation";
import { OrdersConstant } from "src/app/modules/order/shared";
import { DxDataGridComponent } from "devextreme-angular";
import { SecurityGroupSecurityModel } from "src/app/core/models/security-model/security-group-security.model";
import { SecurityGroupService } from "src/app/core/services/system-services/security-group.service";
import { SecurityPaymentAll } from "../payment-search.constant";

@Component({
    selector: 'op-payment-search-results',
    templateUrl: './payment-search-results.component.html'
})
export class PaymentSearchResultsComponent implements OnInit, OnDestroy, AfterViewInit {

    paymentSearch$ = new Observable<PaymentSearch[]>()
    paymentStatusMap: Map<string, PaymentStatusReferenceModel>
    focusing = false

    public rows = 0;
    public selectedItem: any;
    public exportData: any;
    public header: string[];

    public pdfDefaultStyle = {
        fontSize: 7
    };

    public printDefaultStyle = {
        fontSize: 10
    };

    private subscriptions: Subscription[]

    public userSecurity: SecurityGroupSecurityModel;
    @ViewChild('dataGridSearch', { static: false }) dataGrid: DxDataGridComponent;

    constructor(private paymentSearchService: PaymentSearchService,
        private dateConverterService: DateConverterService,
        private stringHelperService: StringHelperService,
        private navigationService: NavigationService,
        private securityGroupService: SecurityGroupService) { }

    ngOnInit(): void {
        this.subscriptions = []
        this.paymentStatusMap = new Map<string, PaymentStatusReferenceModel>()
        this.paymentSearch$ = this.paymentSearchService.paymentSearch$
        this.subscriptions.push(
            this.paymentSearchService.paymentStatus$.subscribe(r => {
                for (const status of r) {
                    this.paymentStatusMap.set(status.paymentStatusCode, status)
                }
            })
        )
    }

    ngAfterViewInit(): void {
        this.getDataGridHeader();
        this.getSecurity();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    private getSecurity() {
        this.subscriptions.push(
            this.securityGroupService.userSecurityGroupSecurity
            .subscribe(r => {
                this.userSecurity = r.find(item => item.securityCode == SecurityPaymentAll)
            })
        )
    }

    selectPayment(e) {
        const selectedPayment = e?.component?.getSelectedRowsData()?.pop()
        this.paymentSearchService.setPaymentSearchSelection(selectedPayment)
    }

    dateTime24Format(date) {
        return this.dateConverterService.convertDateTime24(date)
    }

    validateNullAmountDecimal(amount) {
        return this.stringHelperService.validateNullAmountDecimal(amount)
    }

    findHighlightColorForPaymentStatusName(payment: PaymentSearch): string {
        return this.paymentStatusMap.get(payment.paymentStatusCode)?.highlightColor
    }

    openOrderDetail(ledger: PaymentSearchLedger) {
        this.paymentSearchService.setLoading(true)
        this.subscriptions.push(
            this.paymentSearchService.exchangeOrderId(ledger.orderNumber).subscribe(orderId => {
                this.paymentSearchService.setLoading(false)
                this.navigationService.navigate(`/main/orders/${Date.now().toString()}/details`,
                    OrdersConstant.HomeTitle,
                    true,
                    {
                        id: orderId,
                        orderNumberDisplay: ledger.orderNumber,
                        searchCriteria: {},
                    }
                );
            },
            () => this.paymentSearchService.setLoading(false))
        )

    }

    private getDataGridHeader() {
        this.header = this.dataGrid.instance.getVisibleColumns().map(item => item.caption).filter(item => item);
    }

    public onContentReady(e) {
        this.getNumberOfRows(e);
        this.getExportData()?.done((filteredData) => {
            this.exportData = this.mapExportData(filteredData);
        });
    }

    private getNumberOfRows(e) {
        this.rows = e.component.totalCount();
    }

    private getExportData() {
        let filterExpr = this.dataGrid.instance.getCombinedFilter();
        let gridDataSource = this.dataGrid.instance.getDataSource();
        return gridDataSource?.store()?.load({
            filter: filterExpr
        });  
    }

    public mapExportData(filteredData) {
        return filteredData.map(dat => (
            {
                PaymentNumber: dat.paymentNumberDisplay,
                Organisation: dat.organisationCallName,
                OrderNumber: dat.orderNumber,
                FormOfPaymentType: dat.formOfPaymentTypeName,
                FormOfPayment: dat.formOfPaymentName,
                DocumentNumber: dat.documentNumberDisplay,
                ExternalReference: dat.externalReference,
                PaymentDateTime: this.dateTime24Format(dat.paymentDateTime),
                IssueDateTime: this.dateTime24Format(dat.issueDateTime),
                VoidDateTime: this.dateTime24Format(dat.voidDateTime),
                LedgerCode: dat.ledgerTransactionCode
            }
        ));
    }
}
